import { render, staticRenderFns } from "./eds-iit-checkbox-sign-options.vue?vue&type=template&id=2490846e&scoped=true&lang=pug"
import script from "./eds-iit-checkbox-sign-options.vue?vue&type=script&lang=js"
export * from "./eds-iit-checkbox-sign-options.vue?vue&type=script&lang=js"
import style0 from "./eds-iit-checkbox-sign-options.vue?vue&type=style&index=0&id=2490846e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2490846e",
  null
  
)

export default component.exports